import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import { TaskSection } from "../../api/commands/tasks";
import { ApiError } from "../../api/errors";
import { CommentType } from "../../api/schemas/tasks";
import { Loaded } from "./model";

export const Message = defineMessageUnion({
	/** `id` drops an answer for a task the page has moved off. */
	CompletedFetchTask: {
		id: S.String,
		generation: S.Number,
		now: S.Number,
		result: S.Result(Loaded, ApiError),
	},
	ClickedRescore: {},
	CompletedRescore: { id: S.String, result: S.Result(S.Unknown, ApiError) },
	ChangedDraft: { body: S.String },
	ChangedDraftType: { type: CommentType },
	/** Replies keep the parent's type, so an evidence thread stays evidence. */
	ClickedReply: { commentId: S.String, type: CommentType },
	CompletedFocusComposer: {},
	ClickedCancelReply: {},
	SubmittedComment: {},
	ClickedPromote: { commentId: S.String },
	ClickedDemote: { section: TaskSection, commentId: S.String },
	/** A comment, promote or demote answered; the page refetches either way it lands. */
	CompletedWrite: {
		id: S.String,
		kind: S.Literals(["comment", "section"]),
		result: S.Result(S.Unknown, ApiError),
	},
});
export type Message = typeof Message.Type;
